export default __webpack_public_path__ + "static/media/no_profile.d1c6f8c6.jpg";